<template>
	<div class="m-search">
		<div class="m-search-handle flex-center-cross">
			<c-button color="main" size="search" @click="search">查询</c-button>
			<c-button size="search" @click="clear">重置条件</c-button>
		</div>
		<div class="m-search-content">
			<c-form ref="form" style="padding: 0">
				<div class="flex-wrap">
					<slot></slot>
				</div>
			</c-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'mSearch',
		
		methods: {
			search() {
				this.$emit('search', this.get());
			},
			
			set(data) {
				this.$refs.form.set(data);
			},
			
			get() {
				return this.$refs.form.get();
			},
			
			clear() {
				this.$refs.form.clear();
			}
		}
	}
</script>

<style lang="stylus">
	.m-search {
		padding: 10px 0 10px 20px;
		
		&-handle {
			margin-bottom: 4px;
			
			.c-button {
				margin-right: 9px;
			}
		}
		
		&-item {
			width: 310px;
			height: 36px;
			border-radius: 2px;
			margin-right: 20px;
			margin-top: 10px;
			background: #F2F4F7;
			
			&:focus-within {
				background: #fff;
				outline: 1px solid var(--color-main);
			}
			
			&[colspan="2"] {
				width: 640px
			}
			
			label {
				margin: 0 12px;
				font-size: 12px;
				color: #666;
			}
			
			.c-input,
			.c-select,
			.c-datetime {
				height: 36px !important;
				border: none !important;
				background: none !important;
			}
		}
	}
</style>
